import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import LoginScreen from "./pages/LoginScreen";
import RegisterScreen from "./pages/RegisterScreen";
import ForgotPasswordScreen from "./pages/ForgotPasswordScreen";
import PermissionScreen from "./pages/PermissionScreen";
import OrderGroupScreen from "./pages/OrderGroupScreen";
import WaitingRoomScreen from "./pages/WaitingRoomScreen";
import NotificationScreen from "./pages/NotificationScreen";
import SettingsScreen from "./pages/SettingsScreen";
import MasterScreen from "./pages/MasterScreen";
import ShopGroupScreen from "./pages/ShopGroupScreen";

const getAuthState = () => {
    const isLoggedIn = localStorage.getItem("sifarisLoggedIn") === "true";
    const permissionCompleted =
        localStorage.getItem("sifarisPermissionCompleted") === "true";

    return {
        isLoggedIn,
        permissionCompleted,
    };
};

// Login / Register / Forgot Password səhifələrinə daxil olanda
// əgər user artıq login olubsa, uyğun səhifəyə yönləndir
const AuthRedirect = ({ children }) => {
    const { isLoggedIn, permissionCompleted } = getAuthState();

    if (isLoggedIn && permissionCompleted) {
        return <Navigate to="/sifaris/order-group" replace />;
    }

    if (isLoggedIn && !permissionCompleted) {
        return <Navigate to="/sifaris/permission" replace />;
    }

    return children;
};

// Permission səhifəsinə yalnız login olmuş user girə bilər
// Əgər permission artıq tamamlanıbsa, ana səhifəyə at
const PermissionRoute = ({ children }) => {
    const { isLoggedIn, permissionCompleted } = getAuthState();

    if (!isLoggedIn) {
        return <Navigate to="/sifaris/login" replace />;
    }

    if (permissionCompleted) {
        return <Navigate to="/sifaris/order-group" replace />;
    }

    return children;
};

// Ana səhifəyə yalnız login + permission tamam olan user girə bilər
const ProtectedRoute = ({ children }) => {
    const { isLoggedIn, permissionCompleted } = getAuthState();

    if (!isLoggedIn) {
        return <Navigate to="/sifaris/login" replace />;
    }

    if (!permissionCompleted) {
        return <Navigate to="/sifaris/permission" replace />;
    }

    return children;
};

const SifarisQrupuApp = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/sifaris/login" replace />} />

            <Route
                path="/login"
                element={
                    <AuthRedirect>
                        <LoginScreen />
                    </AuthRedirect>
                }
            />

            <Route
                path="/register"
                element={
                    <AuthRedirect>
                        <RegisterScreen />
                    </AuthRedirect>
                }
            />

            <Route
                path="/forgot-password"
                element={
                    <AuthRedirect>
                        <ForgotPasswordScreen />
                    </AuthRedirect>
                }
            />

            <Route
                path="/permission"
                element={
                    <PermissionRoute>
                        <PermissionScreen />
                    </PermissionRoute>
                }
            />

            <Route
                path="/order-group"
                element={
                    <ProtectedRoute>
                        <OrderGroupScreen />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/waiting-room"
                element={
                    <ProtectedRoute>
                        <WaitingRoomScreen />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/notification"
                element={
                    <ProtectedRoute>
                        <NotificationScreen />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/settings"
                element={
                    <ProtectedRoute>
                        <SettingsScreen />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/master"
                element={
                    <ProtectedRoute>
                        <MasterScreen />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/shop-group"
                element={
                    <ProtectedRoute>
                        <ShopGroupScreen />
                    </ProtectedRoute>
                }
            />

            {/* Tanınmayan route-lar */}
            <Route path="*" element={<Navigate to="/sifaris/login" replace />} />
        </Routes>
    );
};

export default SifarisQrupuApp;